// removed by extract-text-webpack-plugin
module.exports = {"post_slide":"-post_slide__Drxky-"};